<template>
  <EdroneDrawer :open="isDrawerOpen" width="35rem" @close="handleDrawerClose">
    <FreemiumUpgradeDrawerAssasForm
      v-if="
        !!actor?.snapshot.value.hasTag('assasForm') || (isBrazil && !!actor?.snapshot.value.hasTag('upgradingPlan'))
      "
    />

    <FreemiumUpgradeDrawerPricing v-else-if="isPricingView" :price-tiers="priceTiers" @back="handlePricingViewBack" />

    <div v-else class="tw:flex tw:flex-col tw:h-full">
      <EdroneNavigationTop type="drawer">
        <template #header>
          <div class="tw:flex-shrink-0 tw:w-full">
            <EdroneHeader :title="translation.header.title" type="h2" />
          </div>
        </template>
      </EdroneNavigationTop>

      <div class="tw:flex-1 tw:overflow-y-auto tw:flex tw:flex-col tw:gap-4 tw:px-6 tw:pb-10">
        <FreemiumUpgradeDrawerCustomers />

        <p class="tw:body-2--link tw:cursor-pointer" @click="handleOpenTiers">{{ translation.openPricing }}</p>
      </div>

      <div class="tw:flex-shrink-0">
        <FreemiumUpgradeDrawerSummary />
        <FreemiumUpgradeDrawerNavBottom />
      </div>
    </div>
  </EdroneDrawer>
</template>

<script setup lang="ts">
import { inject, computed, watch } from "vue";
import { symbolMachineFreemium } from "vue-app/components/Freemium/Freemium.machine.ts";
import { useFreemiumStore } from "vue-app/components/Freemium/Freemium.store.ts";
import { storeToRefs } from "pinia";
import { amplitudeSendEvent } from "vue-app/utils/amplitude.ts";
import { COUNTRY_ID } from "vue-app/types/enums.ts";
import FreemiumUpgradeDrawerCustomers from "vue-app/components/Freemium/UpgradeDrawer/Customers/FreemiumUpgradeDrawerCustomers.vue";
import FreemiumUpgradeDrawerPricing from "vue-app/components/Freemium/UpgradeDrawer/FreemiumUpgradeDrawerPricing.vue";
import FreemiumUpgradeDrawerAssasForm from "vue-app/components/Freemium/UpgradeDrawer/FreemiumUpgradeDrawerAssasForm.vue";
import FreemiumUpgradeDrawerNavBottom from "vue-app/components/Freemium/UpgradeDrawer/FreemiumUpgradeDrawerNavBottom.vue";
import FreemiumUpgradeDrawerSummary from "./FreemiumUpgradeDrawerSummary.vue";
import EdroneDrawer from "edrone-components/EdroneDrawer.vue";
import EdroneHeader from "edrone-components/EdroneHeader.vue";
import EdroneNavigationTop from "edrone-components/EdroneNavigationTop.vue";

const translation = window._trans._freemium.upgradeDrawer;

const actor = inject(symbolMachineFreemium);
const store = useFreemiumStore();
const { priceTiers } = storeToRefs(store);

const isBrazil = window.EDRONE_CONTEXT.tracker.countryId === COUNTRY_ID.BRAZIL;

const isDrawerOpen = computed(
  () =>
    !!actor?.snapshot.value.hasTag("upgradeDrawer") ||
    !!actor?.snapshot.value.hasTag("manageContacts") ||
    !!actor?.snapshot.value.hasTag("priceTiersDrawer")
);

const isPricingView = computed(() => !!actor?.snapshot.value.hasTag("priceTiersDrawer"));

function handleDrawerClose() {
  amplitudeSendEvent("Freemium_Drawer_Closed");
  actor?.send({ type: "CANCEL" });
}

function handlePricingViewBack() {
  amplitudeSendEvent("Freemium_PricingTiers_Closed");
  actor?.send({ type: "CLOSE" });
}

function handleOpenTiers() {
  amplitudeSendEvent("Freemium_PricingTiers_Opened");
  actor?.send({ type: "OPEN_TIERS" });
}

watch(isDrawerOpen, (isOpen) => {
  if (isOpen) {
    amplitudeSendEvent("Freemium_Drawer_Opened");
  }
});
</script>
